import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const postContactBulkImport = async (file) => {
  const apiURL = API_HOST + '/contacts';
  const { token, userID } = useCurrentUser();
  
  try {
    const { data } = await axios.post(apiURL, file,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
      }
    });
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
